import { useField } from '@unform/core';
import { SwitchField } from 'components';
import React, { ComponentProps, memo, RefObject, useEffect, useRef } from 'react';

interface IProps extends ComponentProps<typeof SwitchField> {
  name: string;
  value?: any;
}

const SwitchComponent: React.FC<IProps> = ({ name, value, ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { registerField, fieldName, defaultValue } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref: RefObject<HTMLInputElement>) => {
        if (value && ref.current?.checked) {
          return value;
        }

        return ref.current?.checked || false;
      },
      setValue: (ref: RefObject<HTMLInputElement>, value) => {
        if (ref.current?.checked) {
          ref.current.checked = !!value;
        }
      },
      clearValue: (ref: RefObject<HTMLInputElement>) => {
        if (ref.current?.checked) {
          ref.current.checked = false;
        }
      },
    });
  }, [fieldName, inputRef, value]);

  return <SwitchField inputRef={inputRef} defaultChecked={!!defaultValue} {...props} />;
};

export const Switch = memo(SwitchComponent);
